/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import React, { useContext } from 'react';

import type { Menu, Reference } from '@swf/cms';
import { CMSContext, useCMSReference } from '@swf/cms';
import useTouchSupported from '@swf/core/hooks/useTouchSupported';

import styles from './CMSNavigationSubmenu.scss';
import CMSNavigationSubmenuChildren from './CMSNavigationSubmenuChildren';
import CMSNavigationSubmenuItem from './CMSNavigationSubmenuItem';

interface Props {
  menuItemRef: Reference;
  onSelect: () => void;
}

const CMSNavigationSubmenu: React.FC<Props> = ({ menuItemRef, onSelect }) => {
  const data = useContext(CMSContext);
  const parentItem = useCMSReference<Menu>(menuItemRef) as Menu;
  const { children } = useCMSReference<Menu>(menuItemRef) as Menu;
  const getSubmenuData = (children: Reference[]) =>
    children.map((item) => data[item.uid] as Menu).filter((item) => item);
  const isTouchSupported = useTouchSupported();

  return (
    <ul className={styles.menu} onMouseLeave={onSelect}>
      {!!isTouchSupported && !!children.length && (
        <li>
          <CMSNavigationSubmenuItem
            pageRef={parentItem.page}
            heading={parentItem.heading}
            url={parentItem.url}
            closeMenu={isTouchSupported}
            className={classNames(styles.menuItem, styles.topMenuItem)}
            onSelect={onSelect}
          />
        </li>
      )}
      {getSubmenuData(children).map(({ heading, children, page, uid, url }, index) => (
        <li key={uid}>
          <CMSNavigationSubmenuItem
            pageRef={page}
            heading={heading}
            url={url}
            className={styles.menuItem}
            onSelect={onSelect}
          />
          {children.length > 0 && (
            <CMSNavigationSubmenuChildren
              menuItems={getSubmenuData(children)}
              parentPageRef={page}
              parentUrl={url}
              onSelect={onSelect}
            />
          )}
        </li>
      ))}
    </ul>
  );
};

export default CMSNavigationSubmenu;
